<template>
  <div id="app">
    <div v-if="testSite" class="test-site-banner"><span>{{ t('test-site-banner') }}</span><span v-if="revision" class="test-site-revision"> · {{ revision }}</span></div>
    <!-- A game page opened from another (e.g. a rematch) starts afresh. -->
    <router-view :key="$route.name === 'game' ? $route.path : undefined"></router-view>
    <!-- The ICP licence, at the foot of every page when the site has one (SPEC §4.1). -->
    <footer v-if="icpLicense" class="icp"><a href="http://beian.miit.gov.cn/">{{ icpLicense }}</a></footer>
  </div>
</template>

<script>
import api from '@/api/api';
import { t } from '@/texts';

export default {
  name: 'App',

  computed: {
    icpLicense() {
      return this.$store.state.site.icpLicense || '';
    },

    testSite() {
      return this.$store.state.site.testSite === true;
    },

    // The commit the page was built from (frontend/Dockerfile), so testers know which build they see.
    revision() {
      const r = process.env.VUE_APP_REVISION;
      return r && r !== 'unknown' ? r : '';
    },
  },

  methods: { t },

  // The site's public information, read once; without it the site shows no banner and no ICP licence.
  async created() {
    try {
      this.$store.commit('set', { site: await api.call('GET', 'site') });
    } catch (e) {
      // keep the empty site information
    }
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

/* Buttons (docs/plans/2026-10-21-ui-review-build.md): one main button per page in wood brown;
   the others white with a wood outline; icon buttons round. Selected choices are amber. */
.btn-main, .btn-secondary, .btn-icon {
  -webkit-appearance: none;
  appearance: none;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 18px;
  font-family: inherit;
  line-height: normal;
  text-align: center;
  cursor: pointer;
}

.btn-main {
  height: 46px;
  border: none;
  border-radius: 10px;
  background: #8b5e34;
  color: #fff;
  font-size: 17px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .25);
}

.btn-secondary {
  height: 42px;
  border: 1px solid #c9b48a;
  border-radius: 10px;
  background: #fff;
  color: #2c3e50;
  font-size: 15px;
}

.btn-icon {
  width: 40px;
  height: 34px;
  padding: 0;
  border: 1px solid #c9b48a;
  border-radius: 17px;
  background: #fff;
  color: #2c3e50;
  font-size: 20px;
}

.btn-main:disabled, .btn-secondary:disabled, .btn-icon:disabled {
  opacity: .45;
  cursor: default;
}

/* A stone drawn before a player's name: black, or white with a dark outline. */
.stone {
  display: inline-block;
  width: .8em;
  height: .8em;
  border-radius: 50%;
  vertical-align: -.08em;
  margin-right: .25em;
  box-sizing: border-box;
  flex: none;
}

.stone.black {
  background: #111;
}

.stone.white {
  background: #fff;
  border: 1.5px solid #333;
}

.icp {
  margin: 24px 0 12px;
  font-size: 12px;
}

.icp a {
  color: #888;
}

.test-site-banner {
  background: #ffc107;
  color: #212529;
  font-size: 14px;
  line-height: 22px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
